import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { timer, Subscription } from 'rxjs';
import { LanguageService } from 'src/app/service/language-service/language.service';
import * as moment from 'moment-timezone';

@Component({
  selector: 'app-checklist-countdown',
  templateUrl: './checklist-countdown.component.html',
  styleUrls: ['./checklist-countdown.component.scss'],
})
export class ChecklistCountdownComponent  implements OnInit {
  language:string = "es";
  translations;
  laguageSub: Subscription;

  @Input() labelClass: string = "";
  @Input() scheduledMsg!: string;
  @Input() fechaVencimiento!: string; // ejemplo: "2026-02-11T17:55:00.000000Z"
  @Input() timezone: string = ""; //ejemplo: "America/Bogota" o "America/Lima" o "America/Tijuana" o etc
  @Input() displayTimeIcon: boolean = false;
  @Output() expirado = new EventEmitter<void>();
  @Output() countdownIsVisible = new EventEmitter<void>();

  dias = '00';
  horas = '00';
  minutos = '00';
  segundos = '00';
  mostrarCountdown = false;
  private subscripcion!: Subscription;

  constructor(private languageService: LanguageService,) { }

  ngOnInit() {
    if (this.fechaVencimiento) {
      this.iniciarCountdown();
    }
  }

  private iniciarCountdown() {
    const fechaFinal = this.parseFecha(this.fechaVencimiento);
    // console.log(" fechaFinal::",fechaFinal.format('YYYY-MM-DD HH:mm:ss Z (z)'),fechaFinal)
    this.subscripcion = timer(0, 1000).subscribe(() => {
      this.actualizarTiempo(fechaFinal);
    });
  }

  private parseFecha(fechaString: string): moment.Moment {
    // Parsear la fecha directamente en el timezone especificado
    // La fecha recibida ya está en ese timezone, no es UTC
    if (this.timezone) {
      return moment.tz(fechaString, this.timezone);
    }
    return moment.utc(fechaString);
  }

  private actualizarTiempo(fechaFinal: moment.Moment) {
    // ahora = Obtener la hora actual equivalente en el timezone especificado
    const ahora = this.timezone ? moment.tz(this.timezone) : moment.utc();
    const diferencia = fechaFinal.diff(ahora);
    // console.log({ahora: ahora.format('YYYY-MM-DD HH:mm:ss Z'), diferencia: diferencia});

    if (diferencia <= 0) {
      this.expirado.emit();
      // console.log(this.subscripcion)
      this.subscripcion?.unsubscribe();
      return;
    }

    this.mostrarCountdown = diferencia < (60 * 60 * 1000);
    // this.mostrarCountdown = diferencia < (1 * 24 * 60 * 60 * 1000);
    if(this.mostrarCountdown) {
      this.countdownIsVisible.emit();
    }
    // console.log("mostrarCountdown", this.mostrarCountdown)

    const duracion = moment.duration(diferencia);
    const segundos = duracion.seconds();
    const minutos = duracion.minutes();
    const horas = duracion.hours();
    const dias = Math.floor(duracion.asDays());

    this.dias = this.formatearTiempo(dias);
    this.horas = this.formatearTiempo(horas);
    this.minutos = this.formatearTiempo(minutos);
    this.segundos = this.formatearTiempo(segundos);

    // console.log({dias: this.dias, horas: this.horas, minutos: this.minutos, segundos: this.segundos});
  }

  private formatearTiempo(tiempo: number): string {
    return tiempo < 10 ? `0${tiempo}` : `${tiempo}`;
  }

  ngOnDestroy() {
    this.subscripcion?.unsubscribe();
  }

  subLanguageConfig() {
    this.laguageSub = this.languageService.getCurrentLang().subscribe(lang => {
      this.language = lang;
      this.languageService.getChecklistTranslateFile(this.language).subscribe(
      {
        next: (data) => {
         this.translations = data;
        },
        error: (e) => {
          console.log(e);
        }
      }
    );

    });
  }

}
